import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {UserRole} from "../type/user-role";

@Component({
    selector: 'app-user-role-add',
    templateUrl: './user-role-add.component.html',
})
export class UserRoleAddComponent implements OnInit {
    node = 'user-role';

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private location: Location
    ) {}

    ngOnInit() {
        this.dataService.refresh();
    }

    onFormSubmit(formData) {
        var data = {
            user_role: formData.value.user_role,
            user_role_level: formData.value.user_role_level,
            user_role_status: formData.value.user_role_status,
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: User Role added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/user-roles/user-role-add.component.ts